module.exports = __webpack_public_path__ + "static/img/about051.57876a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about051.png
// module id = 08yT
// module chunks = 1